import {useCallback} from "react";
import {
    InputField,
    SelectUserAll
} from "~/components/Forms";
import {useCan} from "~/hooks";

function BuilderLicenseSearchBar({filter, onSearchChange, onChange}) {
    const can = {
        listAll: useCan('builderLicenseListAll'),
    };

    const handleKeywordChange = (e) => {
        if (!onSearchChange) return;
        const newFilter = {
            ...filter,
            keyword: e.target.value,
            page: 1,
        };
        onSearchChange(newFilter);
    };

    const handleUserChange = useCallback((value) => {
        if (!onChange) return;
        onChange('userId', value);
    }, [onChange]);

    return (
        <div className="search-bar">
            <div className="container">
                <form className="form" autoComplete="off">
                    <InputField
                        name="keyword"
                        placeholder="Tên miền, tên website, license key"
                        onChange={handleKeywordChange}
                        defaultValue={filter.keyword}
                    />
                    {can.listAll && (
                        <SelectUserAll
                            name="user"
                            placeholder="Người tạo"
                            options={[{value:'', label:'Tất cả'}]}
                            onChange={handleUserChange}
                            value={filter.userId}
                        />
                    )}
                </form>
            </div>
        </div>
    );
}

export default BuilderLicenseSearchBar;

